// import React, { useState } from "react";
// import "./Logs.css";
// import {
//   Box,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Checkbox,
//   IconButton,
//   TablePagination,
//   Modal,
//   TextField,
// } from "@mui/material";

// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import CloseIcon from "@mui/icons-material/Close";

// const initialData = [
//   {
//     id: 1,
//     empId: "EMP001",
//     name: "Rahul Kumar",
//     present: 22,
//     working: 26,
//     leaves: 4,
//     total: 26,
//     lop: 0,
//     hours: 176,
//   },
//   {
//     id: 2,
//     empId: "EMP002",
//     name: "Amit Singh",
//     present: 20,
//     working: 26,
//     leaves: 6,
//     total: 26,
//     lop: 2,
//     hours: 160,
//   },
// ];

// const Logs = () => {
//   const [data, setData] = useState(initialData);
//   const [year, setYear] = useState("2024");
//   const [month, setMonth] = useState("January");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   const [openView, setOpenView] = useState(false);
//   const [openEdit, setOpenEdit] = useState(false);
//   const [selectedRow, setSelectedRow] = useState(null);

//   /* ================= IMPORT ================= */
//   const handleImport = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = (evt) => {
//       const rows = evt.target.result.split("\n").slice(1);
//       const parsed = rows
//         .map((row, i) => {
//           const c = row.split(",");
//           if (c.length < 8) return null;
//           return {
//             id: i + 1,
//             empId: c[0],
//             name: c[1],
//             present: +c[2],
//             working: +c[3],
//             leaves: +c[4],
//             total: +c[5],
//             lop: +c[6],
//             hours: +c[7],
//           };
//         })
//         .filter(Boolean);
//       setData(parsed);
//     };
//     reader.readAsText(file);
//   };

//   /* ================= EXPORT ================= */
//   const handleExport = () => {
//     const csv = [
//       "EmpId,Name,Present,Working,Leaves,Total,LOP,Hours",
//       ...data.map(
//         (d) =>
//           `${d.empId},${d.name},${d.present},${d.working},${d.leaves},${d.total},${d.lop},${d.hours}`
//       ),
//     ].join("\n");

//     const blob = new Blob([csv], { type: "text/csv" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "logs.csv";
//     a.click();
//   };

//   /* ================= DELETE ================= */
//   const handleDelete = (id) => {
//     if (window.confirm("Are you sure you want to delete?")) {
//       setData(data.filter((d) => d.id !== id));
//     }
//   };

//   /* ================= SAVE EDIT ================= */
//   const handleSave = () => {
//     setData(data.map((d) => (d.id === selectedRow.id ? selectedRow : d)));
//     setOpenEdit(false);
//   };

//   return (
//     <Box className="logs-wrapper">
//       {/* FILTERS */}
//       <Box className="logs-filters">
//         <FormControl size="small">
//           <InputLabel>Year</InputLabel>
//           <Select value={year} label="Year" onChange={(e) => setYear(e.target.value)}>
//             <MenuItem value="2024">2024</MenuItem>
//             <MenuItem value="2023">2023</MenuItem>
//           </Select>
//         </FormControl>

//         <FormControl size="small">
//           <InputLabel>Month</InputLabel>
//           <Select value={month} label="Month" onChange={(e) => setMonth(e.target.value)}>
//             {["January","February","March","April","May","June","July","August","September","October","November","December"].map((m) => (
//               <MenuItem key={m} value={m}>{m}</MenuItem>
//             ))}
//           </Select>
//         </FormControl>

//         <Box className="logs-actions">
//           <input hidden type="file" accept=".csv" id="csv" onChange={handleImport} />
//           <Button onClick={() => document.getElementById("csv").click()} variant="contained" color="success" startIcon={<CloudUploadIcon />}>
//             Import
//           </Button>
//           <Button onClick={handleExport} variant="contained" startIcon={<CloudDownloadIcon />}>
//             Export
//           </Button>
//         </Box>
//       </Box>

//       {/* TABLE */}
//       <TableContainer component={Paper} className="logs-table">
//         <Table stickyHeader size="small">
//           <TableHead>
//             <TableRow>
//               <TableCell>S.No</TableCell>
//               <TableCell>Emp ID</TableCell>
//               <TableCell>Name</TableCell>
//               <TableCell>Present</TableCell>
//               <TableCell>Working</TableCell>
//               <TableCell>Leaves</TableCell>
//               <TableCell>LOP</TableCell>
//               <TableCell>Hours</TableCell>
//               <TableCell>Action</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => (
//               <TableRow key={row.id}>
//                 <TableCell>{i + 1}</TableCell>
//                 <TableCell>{row.empId}</TableCell>
//                 <TableCell>{row.name}</TableCell>
//                 <TableCell>{row.present}</TableCell>
//                 <TableCell>{row.working}</TableCell>
//                 <TableCell>{row.leaves}</TableCell>
//                 <TableCell>{row.lop}</TableCell>
//                 <TableCell>{row.hours}</TableCell>
//                 <TableCell>
//                   <IconButton onClick={() => { setSelectedRow(row); setOpenView(true); }}>
//                     <VisibilityIcon />
//                   </IconButton>
//                   <IconButton color="warning" onClick={() => { setSelectedRow(row); setOpenEdit(true); }}>
//                     <EditIcon />
//                   </IconButton>
//                   <IconButton color="error" onClick={() => handleDelete(row.id)}>
//                     <DeleteIcon />
//                   </IconButton>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>

//         <TablePagination
//           component="div"
//           count={data.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={(e, p) => setPage(p)}
//           onRowsPerPageChange={(e) => setRowsPerPage(+e.target.value)}
//         />
//       </TableContainer>

//       {/* VIEW MODAL */}
//       <Modal open={openView} onClose={() => setOpenView(false)}>
//         <Box className="modal-box">
//           <IconButton className="close-btn" onClick={() => setOpenView(false)}>
//             <CloseIcon />
//           </IconButton>
//           <h3>Employee Details</h3>
//           {selectedRow && Object.entries(selectedRow).map(([k, v]) => (
//             <p key={k}><b>{k}:</b> {v}</p>
//           ))}
//         </Box>
//       </Modal>

//       {/* EDIT MODAL */}
//       <Modal open={openEdit} onClose={() => setOpenEdit(false)}>
//         <Box className="modal-box">
//           <IconButton className="close-btn" onClick={() => setOpenEdit(false)}>
//             <CloseIcon />
//           </IconButton>
//           <h3>Edit Employee</h3>

//           {selectedRow && Object.keys(selectedRow).map((key) =>
//             key !== "id" && (
//               <TextField
//                 key={key}
//                 label={key}
//                 fullWidth
//                 margin="dense"
//                 value={selectedRow[key]}
//                 onChange={(e) =>
//                   setSelectedRow({ ...selectedRow, [key]: e.target.value })
//                 }
//               />
//             )
//           )}

//           <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={handleSave}>
//             Save Changes
//           </Button>
//         </Box>
//       </Modal>
//     </Box>
//   );
// };

// export default Logs;


import React, { useState } from "react";
import "./Logs.css";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Modal,
  TextField,
} from "@mui/material";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

const initialData = [
  {
    id: 1,
    empId: "EMP001",
    name: "Rahul Kumar",
    present: 22,
    working: 26,
    leaves: 4,
    lop: 0,
    totalDays: 22 + 26 + 4,
    hours: 176,
  },
  {
    id: 2,
    empId: "EMP002",
    name: "Amit Singh",
    present: 20,
    working: 26,
    leaves: 6,
    lop: 2,
    totalDays: 22 + 26 + 6,
    hours: 160,
  },
];

const Logs = () => {
  const [data, setData] = useState(initialData);
  const [year, setYear] = useState("2024");
  const [month, setMonth] = useState("January");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [openView, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  /* ================= IMPORT CSV ================= */
  const handleImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const rows = evt.target.result.split("\n").slice(1);
      const parsed = rows
        .map((row, i) => {
          const c = row.split(",");
          if (c.length < 7) return null;
          return {
            id: i + 1,
            empId: c[0],
            name: c[1],
            present: +c[2],
            working: +c[3],
            leaves: +c[4],
            lop: +c[5],
            totalDays: +c[2] + +c[3] + +c[4],
            hours: +c[6],
          };
        })
        .filter(Boolean);
      setData(parsed);
    };
    reader.readAsText(file);
  };

  /* ================= EXPORT CSV ================= */
  const handleExport = () => {
    const csv = [
      "EmpId,Name,Present,Working,Leaves,LOP,Total Days,Hours",
      ...data.map(
        (d) =>
          `${d.empId},${d.name},${d.present},${d.working},${d.leaves},${d.lop},${d.totalDays},${d.hours}`
      ),
    ].join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "logs.csv";
    a.click();
  };

  /* ================= DELETE ================= */
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      setData(data.filter((d) => d.id !== id));
    }
  };

  /* ================= SAVE EDIT ================= */
  const handleSave = () => {
    setData(data.map((d) => (d.id === selectedRow.id ? selectedRow : d)));
    setOpenEdit(false);
  };

  return (
    <Box className="logs-wrapper">
      {/* FILTERS */}
      <Box className="logs-filters">
        <FormControl size="small">
          <InputLabel>Year</InputLabel>
          <Select value={year} label="Year" onChange={(e) => setYear(e.target.value)}>
            <MenuItem value="2024">2024</MenuItem>
            <MenuItem value="2023">2023</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small">
          <InputLabel>Month</InputLabel>
          <Select value={month} label="Month" onChange={(e) => setMonth(e.target.value)}>
            {[
              "January","February","March","April","May","June",
              "July","August","September","October","November","December",
            ].map((m) => (
              <MenuItem key={m} value={m}>{m}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box className="logs-actions">
          <input hidden type="file" accept=".csv" id="csv-upload" onChange={handleImport} />
          <Button
            variant="contained"
            color="success"
            startIcon={<CloudUploadIcon />}
            onClick={() => document.getElementById("csv-upload").click()}
          >
            Import
          </Button>

          <Button
            variant="contained"
            startIcon={<CloudDownloadIcon />}
            onClick={handleExport}
          >
            Export
          </Button>
        </Box>
      </Box>

      {/* TABLE */}
      <TableContainer component={Paper} className="logs-table">
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Employee ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Present</TableCell>
              <TableCell>Working</TableCell>
              <TableCell>Leaves</TableCell>
              <TableCell>LOP</TableCell>
              <TableCell>Total Days</TableCell>
              <TableCell>Hours</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, i) => (
                <TableRow key={row.id}>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell>{row.empId}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.present}</TableCell>
                  <TableCell>{row.working}</TableCell>
                  <TableCell>{row.leaves}</TableCell>
                  <TableCell>{row.lop}</TableCell>
                  <TableCell>{row.totalDays}</TableCell>

                  <TableCell>{row.hours}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => { setSelectedRow(row); setOpenView(true); }}>
                      <VisibilityIcon />
                    </IconButton>
                    <IconButton color="warning" onClick={() => { setSelectedRow(row); setOpenEdit(true); }}>
                      <EditIcon />
                    </IconButton>
                    <IconButton color="error" onClick={() => handleDelete(row.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={data.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={(e, p) => setPage(p)}
          onRowsPerPageChange={(e) => setRowsPerPage(+e.target.value)}
        />
      </TableContainer>

      {/* VIEW MODAL */}
      <Modal open={openView} onClose={() => setOpenView(false)}>
        <Box className="modal-box">
          <IconButton className="close-btn" onClick={() => setOpenView(false)}>
            <CloseIcon />
          </IconButton>

          <h3>Employee Details</h3>

          {selectedRow && (
            <div className="view-grid">
              <div className="view-item"><span>Employee ID</span><strong>{selectedRow.empId}</strong></div>
              <div className="view-item"><span>Name</span><strong>{selectedRow.name}</strong></div>
              <div className="view-item"><span>Present</span><strong>{selectedRow.present}</strong></div>
              <div className="view-item"><span>Working</span><strong>{selectedRow.working}</strong></div>
              <div className="view-item"><span>Leaves</span><strong>{selectedRow.leaves}</strong></div>
              <div className="view-item"><span>LOP</span><strong>{selectedRow.lop}</strong></div>
              <div className="view-item"><span>Total-Days</span><strong>{selectedRow.totalDays}</strong></div>
              <div className="view-item"><span>Total Hours</span><strong>{selectedRow.hours}</strong></div>
            </div>
          )}
        </Box>
      </Modal>

      {/* EDIT MODAL */}
      <Modal open={openEdit} onClose={() => setOpenEdit(false)}>
        <Box className="modal-box">
          <IconButton className="close-btn" onClick={() => setOpenEdit(false)}>
            <CloseIcon />
          </IconButton>

          <h3>Edit Employee</h3>

          {selectedRow && (
            <div className="edit-grid">
              <TextField label="Employee ID" value={selectedRow.empId} fullWidth disabled />
              <TextField label="Name" value={selectedRow.name}
                onChange={(e) => setSelectedRow({ ...selectedRow, name: e.target.value })} />

              <TextField label="Present" type="number" value={selectedRow.present}
                onChange={(e) => setSelectedRow({ ...selectedRow, present: e.target.value })} />

              <TextField label="Working" type="number" value={selectedRow.working}
                onChange={(e) => setSelectedRow({ ...selectedRow, working: e.target.value })} />

              <TextField label="Leaves" type="number" value={selectedRow.leaves}
                onChange={(e) => setSelectedRow({ ...selectedRow, leaves: e.target.value })} />

              <TextField label="LOP" type="number" value={selectedRow.lop}
                onChange={(e) => setSelectedRow({ ...selectedRow, lop: e.target.value })} />
                <TextField label="Total Days" type="number" value={selectedRow.totalDays}
                onChange={(e) => setSelectedRow({ ...selectedRow, totalDays: e.target.value })} />

              <TextField label="Hours" type="number" value={selectedRow.hours}
                onChange={(e) => setSelectedRow({ ...selectedRow, hours: e.target.value })} />

              <div className="edit-actions">
                <Button variant="contained" fullWidth onClick={handleSave}>
                  Save Changes
                </Button>
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default Logs;
